export interface DocCenterColumnResponse {
    selector: {
        '#popups-column': string;
    };
}

export interface DocCenterResponse {
    content: string;
}

export interface DocCenterData {
    id: string | DocCenterTooltip;
    value: string;
}

export enum DocCenterGeneralTooltip {
    pricesWizardPhrases = 'bid-wizard-phrases',
    mobileAppTrackingId = 'mobile-apps-ads-tracking-id'
}

export enum DocCenterColumnTooltip {
    campaignType = 'campaign-type',
    cost = 'cost',
    revenue = 'revenue',
    profitability = 'profitability',
    avgGoalCost = 'cpa',
    avgClickCost = 'cpc',
    avgCpmCost = 'cpm',
    shows = 'shows',
    clicks = 'clicks',
    ctr = 'ctr',
    goals = 'goals',
    conversionRate = 'converison-rate',
    bounceRate = 'bounce-rate',
    moscowTime = 'moscow-time',
    filter = 'filterTooltip',
    bid = 'bid',
    trafficForecast = 'traffic-forecast',
    clickPrice = 'click-price',
    bidInNetworks = 'bid-in-networks',
    coverage = 'coverage',
    priority = 'priority',
    cpmBid = 'cpm-bid'
}

export enum HelpLink {
    campaignTypes = 'cost-all-phrases',
    shows = 'selecting-strategy',
    ctr = 'positions',
    clicks = 'timetargeting',
    avgGoalCost = 'wrong',
    filter = 'filters',
    turbo = 'turbo-landing-page',
    viewAd = 'view-ad',
    adsExperiments = 'adsExperiments',
    retargetingBidsAdjustment = 'retargeting-bids-adjustment',
    deviceBidsAdjustment = 'device-bids-adjustment',
    socialDemographicBidsAdjustment = 'social-demographic-bids-adjustment',
    videoExtensionBidsAdjustment = 'video-extension-bids-adjustment',
    smartAdsBidsAdjustment = 'smart-ads-bids-adjustment',
    inventoryAdsBidsAdjustment = 'traffic-type-bids-adjustment',
    price = 'price',
    weatherBidsAdjustment = 'weather-bids-adjustment',
    trafficJamBidsAdjustment = 'congestion-bids-adjustment'
}

export type DocCenterTooltip = DocCenterGeneralTooltip | DocCenterColumnTooltip | HelpLink;

export type Tooltips = Partial<Record<DocCenterTooltip, string>>;
